<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-checkbox
            :error-messages="error"
            v-model="isChecked"
        >
          <template #label>
            <div v-if="isLegal">
              {{
                translation(translationList.rca_legal_agreement, 'Declar pe propria răspundere ca sunt reprezentat legal / împuternicit de catre persona juridica care este proprietar sau utilizator al autovehiculului.*')
              }}
            </div>
            <div v-else>
              {{
                translation(translationList.rca_individual_agreement, 'Declar pe propria răspundere ca sunt persoana fizica si am in proprietate acest autovehicul sau am drept legal de utilizare pentru acest autovehicul*')
              }}
            </div>
          </template>
        </v-checkbox>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import {defineComponent, ref, watch, onMounted, type PropType} from 'vue';
import {useTranslationStore, translation} from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  name: 'RcaCustomerAgreement',
  props: {
    modelValue: {
      type: [Boolean, null] as PropType<boolean | null>,
      default: false,
    },
    isLegal: {
      type: Boolean,
      default: false,
    }
  },
  setup(props, {emit}) {
    const isChecked = ref(props.modelValue);
    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();
    const error = ref<string[]>([]);

    watch(isChecked, (newValue) => {
      emit('update:modelValue', newValue);
    });

    watch(() => props.modelValue, (newValue) => {
      isChecked.value = newValue;
      error.value = [];
      const isValid = isChecked.value;
      emit('validation-rca-status', {field: 'customer_agreement', isValid});
    });

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');

      // Listen for validate event
      window.addEventListener('validate-customer', (data) => {
        if (data.detail && data.detail === 'customer_agreement') {
          if (!isChecked.value) {
            error.value = [translation(translationList.value.required_rca_agreement, 'Te rugăm să citești și să accepți termenii și condițiile pentru a putea continua')];
          } else {
            error.value = [];
            emit('validation-rca-status', {field: 'customer_agreement', isValid: true});
          }
        }
      });
    });

    return {
      isChecked,
      translationList,
      translation,
      error,
    };
  },
});
</script>

<style scoped>
</style>